<template>
    <div class="scr-body">
        <div class="scr-body-objectives">
            <h2>Visit objectives</h2>
            <br />
            <ol class="order-list">
                <li v-for="(objective, index) in visitObjectives" :key="index">{{objective}}</li>
            </ol>

            <button @click="closeModal" class="btn">
                <i class="icon-arrow-alt-left"></i> Back to my schedule
            </button>
        </div>
    </div>
</template>

<script>
//This component is presenting the visit objectives.
export default {
    name: "Objectives",
    data() {
        return {
            visit: this.$store.getters.visit
        };
    },
    methods: {
        closeModal() {
            this.$router.push("/schedule");
        }
    },
    computed: {
        visitObjectives() {
            return this.visit.objectives;
        }
    }
};
</script>

<style>
</style>